import script from "./BaseBuilder.vue?vue&type=script&lang=js"
export * from "./BaseBuilder.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__